export var MODERATION_MESSAGE_RESULT = {
  NOT_MODERATED: 'Mensagem em análise para aprovação.',
  REJECTED: 'Mensagem bloqueada por conter dados sensíveis.',
  WAITING_MODERATION: 'Mensagem em análise para aprovação.'
};